module.exports = __webpack_public_path__ + "static/media/dark_ru.3c0305b6.svg";